<template>
  {{ _t(this.find()) }}
</template>
<script>
export default {
  name: 'CustomSelectedOption',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: null,
      default: null,
    },
    optionLabel: {
      type: String,
      default: '',
    },
    optionValue: {
      type: String,
      default: '',
    },
    default: {
      type: String,
      default: '',
    }
  },
  methods: {
    find() {
      const found = this.optionValue ? this.options.find(item => item[this.optionValue] === this.modelValue) : this.options.find(item => item === this.modelValue)
      if (found) {
        return this.optionLabel ? found[this.optionLabel] : found
      }
      return this.default ?? ''
    }
  }
}
</script>
